// extracted by mini-css-extract-plugin
module.exports = {"waterfall":"_1147","noCompleteTips":"_18126","center":"_13898"};